import { render, staticRenderFns } from "./tab_group.vue?vue&type=template&id=6505bfc4&"
import script from "./tab_group.vue?vue&type=script&lang=js&"
export * from "./tab_group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports